import { gapi } from 'gapi-script';
import React, { useEffect, useState } from 'react';

const CLIENT_ID ="523035007236-7f6m5foajf6ecrk25klplsl0e3t8abom.apps.googleusercontent.com"; // Replace with your actual client ID
const API_KEY = "AIzaSyBQTjwInbt7LjpL2T1X7NjfPGUBHDbSGQs"; // Replace with your actual API key
const DISCOVERY_DOCS = ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"];
const SCOPES = "https://www.googleapis.com/auth/calendar.events";

function GoogleAuth(showemailoptionnoww) {

  const [isSignedIn, setIsSignedIn] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    function start() {
      gapi.client.init({
        apiKey: API_KEY,
        clientId: CLIENT_ID,
        discoveryDocs: DISCOVERY_DOCS,
        scope: SCOPES,
      }).then(() => {
        const authInstance = gapi.auth2.getAuthInstance();

        const signedIn = authInstance.isSignedIn.get();
        setIsSignedIn(signedIn);

        console.log("Initial signed in state:", signedIn);

        if (signedIn) {
          const profile = authInstance.currentUser.get().getBasicProfile();
          setUserProfile({
            name: profile.getName(),
            email: profile.getEmail(),
            imageUrl: profile.getImageUrl(),
          });
          console.log("User profile:", profile);
          if (showemailoptionnoww.setUserdatanow) {
            showemailoptionnoww.setUserdatanow({
              name: profile.getName(),
              email: profile.getEmail(),
              imageUrl: profile.getImageUrl(),
            });
          }

          showemailoptionnoww.showemailoptionnow(true);

        }

        authInstance.isSignedIn.listen(() => {
          const signedIn = authInstance.isSignedIn.get();
          setIsSignedIn(signedIn);
          showemailoptionnoww.showemailoptionnow(true);
          console.log("Sign-in state changed:", signedIn);

          if (signedIn) {
            const profile = authInstance.currentUser.get().getBasicProfile();
            setUserProfile({
              name: profile.getName(),
              email: profile.getEmail(),
              imageUrl: profile.getImageUrl(),
            });
            console.log("User profile:", profile);
            showemailoptionnoww.setUserdatanow({
              name: profile.getName(),
              email: profile.getEmail(),
              imageUrl: profile.getImageUrl(),
            });
          } else {
            setUserProfile(null);
            showemailoptionnoww.setUserdatanow("");
            console.log("User signed out");
          }
        });
      }).catch((error) => {
        console.error("Error loading GAPI client:", error);
      });
    }

    gapi.load('client:auth2', start);
  }, []);

  const handleAuthClick = () => {
    gapi.auth2.getAuthInstance().signIn().catch((error) => {
      console.error("Error signing in:", error);     
    });
  };

  const handleSignOutClick = () => {
    gapi.auth2.getAuthInstance().signOut().catch((error) => {
      console.error("Error signing out:", error);
      setIsSignedIn(false);
      setUserProfile(null);
    });
  };

  return (
    <div className="p-5">
      {isSignedIn ? (
        <div>
          <p>You are signed in</p>
          <div className="d-flex align-items-center justify-content-start mt-1">
            <img src={userProfile?.imageUrl} referrerPolicy="no-referrer" style={{ width: '50px', borderRadius: '50%' }} />
            {/* <button class="btn btn-primary" type="submit" onClick={handleSignOutClick}>Sign Out</button> */}

            <span className='ms-3'>
              <h6 className="mb-0">{userProfile?.name}</h6>
              <p className="mb-0" >{userProfile?.email}</p>
            </span>


            {/* <img src={userProfile?.imageUrl} alt={userProfile?.name} style={{ width: '50px', borderRadius: '50%' }} /> &nbsp;&nbsp; */}
            {/* <button title="Sign-out" className="btn btn-primary ms-2" type="submit" onClick={handleSignOutClick}><i class="fa fa-sign-out"></i></button> */}
            <button
              className="btn btn-primary ms-4 Signoutbtn"
              type="submit"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}   
              onClick={handleSignOutClick}
            >
              <i className="fa fa-sign-out"></i>
              {showTooltip && <span className="customtooltip">Sign-out</span>}
            </button>
          </div>
        </div>
      ) : (
        <div>
          <p>You are not signed in.</p>
          <button onClick={handleAuthClick} class="btn btn-primary" type="submit">Sign In</button>
        </div>
      )}
    </div>
  );
}

export default GoogleAuth;
